import React from "react";
import t from "../../../../helpers/t";
const UserSelect = (props) => {
  const { users, setUser } = props;
  const onChangeUser = (user, e) => {
    setUser(user);
  };
  return (
    <>
      {users.length < 1 ? (
        <>
          <div className="inb-c-item inb-c-item--from row" key="noid">
            <div className="small-12 medium-12 column" style={{ textAlign: "center" }}>
              {t("no customers found.")}
            </div>{" "}
          </div>
        </>
      ) : (
        users.map((user) => {
          return (
            <>
              <div className="inb-c-item inb-c-item--from row" key={user.id}>
                <div className="small-6 medium-4 column" key={"name_" + user.id}>
                  {user.first_name} {user.last_name}
                </div>
                <div className="small-3 medium-3 column" key={"usernbr_" + user.id}>
                  {user.customer_nbr}
                </div>
                <div className="small-6 medium-3 column" key={"email_" + user.id}>
                  {user.email}
                </div>
                <div className="small-6 medium-2 column" key={"button_" + user.id}>
                  <input
                    type="button"
                    className="button beautify"
                    style={{ marginTop: "5px" }}
                    onClick={(e) => onChangeUser(user, e)}
                    value="Auswählen"
                  />
                </div>
              </div>
            </>
          );
        })
      )}
    </>
  );
};
export default UserSelect;
